<div class="account-glass">
  <div class="profile-header">
  
    <div class="user-meta" *ngFor="let address of addressDetailsByCustomerId">
      <h2>{{ address.Name }}</h2>
      <p>{{ address.Email }}</p>
      <p>{{ address.Contact }}</p>
    </div>
  </div>

  <div class="section" *ngFor="let address of addressDetailsByCustomerId">
    <h3>📍 Address</h3>
    <div class="info-box">
      <p>{{ address.Address }}</p>
      <button class="btn-outline" (click)="editAddress()">Edit</button>
    </div>
  </div>

  <div class="section">
    <h3>🛍️ Orders</h3>
    <!-- <div *ngIf="orderDetailsByCustomerId.length > 0; else noOrders">
      <div class="order-card" *ngFor="let order of orderDetailsByCustomerId">
        <div class="order-top">
          <span class="order-id">#{{ order.orderId }}</span>
          <span class="status" [ngClass]="order.status">{{ order.status }}</span>
        </div>
        <div class="order-bottom">
          <p>{{ order.order_date }}</p>
          <p>Total: ₹{{ order.totalAmount }}</p>
          <button class="btn-primary" (click)="viewOrder(order.id)">View</button>
        </div>
      </div>
    </div> -->
     <div *ngIf="orderDetailsByCustomerId.length > 0; else noOrders">
    <div class="order-card" *ngFor="let order of orderDetailsByCustomerId">
      <!-- <div class="order-image">
        <img [src]="order.cart.productImage" alt="{{ order.cart.productName }}" />
      </div> -->

      <div class="order-details">
        <h4>{{ order.cart.productName }}</h4>
        <p><strong>Order #{{ order.orderId }}</strong></p>
        <p>Date: {{ order.orderDate }}</p>
        <p>Total: ₹{{ order.totalAmount }}</p>
        <span class="badge" [ngClass]="order.status">{{ order.status }}</span>
        <!-- <button class="btn-view" (click)="viewOrder(order.id)">View Details</button> -->
         <a href="View Details" (click)="viewOrder(order.orderId)">View Details</a>
      </div>
    </div>
  </div>
    <ng-template #noOrders>
      <p class="empty">No orders yet. Start shopping!</p>
    </ng-template>
  </div>

  <div class="logout-area">
    <button class="btn-danger" (click)="logout()">Logout</button>
  </div>
</div>
